import { css } from '@/styled-system/css';

export const link = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'md',
  color: 'hpxTeal500',
  textDecoration: 'none',
  fontWeight: 'bold',

  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const icon = css({
  width: '14px',
  height: '14px',
  marginLeft: 'xs',
});
